import React from 'react';
import PropTypes from 'prop-types';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import calculateDistance from '../../../shared/utils/calculateDistance';

function VehicleStatisticsWidget({
  coordsState,
  coords,
  enableGeozoneNames,
  setEnableGeozoneNames,
  enableMapRoutes,
  setEnableMapRoutes,
}) {
  return (
    <Box sx={{ marginBottom: '10px' }}>
      <Typography id="non-linear-slider" gutterBottom>
        Пробег:{' '}
        {(coordsState?.length
          ? coordsState.length > 1 &&
            calculateDistance(coordsState.map((point) => [point.latitude / 10000000, point.longitude / 10000000]))
          : coords?.length > 1 &&
            calculateDistance(coords.map((point) => [point.latitude / 10000000, point.longitude / 10000000]))) ||
          0}{' '}
        км.
      </Typography>

      <Typography id="non-linear-slider" gutterBottom>
        Расход: -
      </Typography>

      <Typography id="non-linear-slider" gutterBottom>
        На 100 км: -
      </Typography>

      <FormControlLabel
        control={<Checkbox checked={enableMapRoutes} onChange={(e) => setEnableMapRoutes(e.target.checked)} />}
        label="Показ маршрутов"
      />

      <FormControlLabel
        control={<Checkbox checked={enableGeozoneNames} onChange={(e) => setEnableGeozoneNames(e.target.checked)} />}
        label="Показ названий геозон"
      />
    </Box>
  );
}

VehicleStatisticsWidget.propTypes = {
  coordsState: PropTypes.arrayOf(PropTypes.shape({ longitude: PropTypes.number, latitude: PropTypes.number })),
  coords: PropTypes.arrayOf(PropTypes.shape({ longitude: PropTypes.number, latitude: PropTypes.number })),
  enableGeozoneNames: PropTypes.bool.isRequired,
  setEnableGeozoneNames: PropTypes.func.isRequired,
  enableMapRoutes: PropTypes.bool.isRequired,
  setEnableMapRoutes: PropTypes.func.isRequired,
};

VehicleStatisticsWidget.defaultProps = {
  coordsState: [],
  coords: [],
};

export default VehicleStatisticsWidget;
